import React from 'react'
import PropTypes from 'prop-types'

const Tabs = (props) => {
  const { children, activeTab, setActiveTab, className } = props
  return (
    <React.Fragment>
      <ul className={`tabs ${className ? className : ''}`}>
        {(Array.isArray(children) ? children : [children]).map((child) => {
          return (
            <li
              id={child.props.id ?? child.props.eventKey}
              key={child.props.eventKey}
              className={`tabs__label ${child.props.eventKey === activeTab ? '-active' : ''}`}
            >
              <button
                disabled={child.props.disabled}
                onClick={() => setActiveTab(child.props.eventKey)}
              >
                {child.props.title}
              </button>
            </li>
          )
        })}
      </ul>
      {(Array.isArray(children) ? children : [children]).map((child, idx) => (
        <div
          key={idx}
          className={`tabs__content ${child.props.eventKey === activeTab ? '-active' : ''} ${
            child.props.className || ''
          }`}
        >
          {child.props.children}
        </div>
      ))}
    </React.Fragment>
  )
}

Tabs.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  activeTab: PropTypes.string.isRequired,
  setActiveTab: PropTypes.func.isRequired,
  className: PropTypes.string,
}

export default Tabs
